export default __webpack_public_path__ + "static/media/arrowTutor.02e3f5d2.svg";